
import { grey } from '@material-ui/core/colors';

export default () => ({
  gridItem: {
    zIndex: 0,
    minWidth: 300,
  },
  greyColor: { color: grey[600] },
  footerIcon: {
    color: grey[600],
    marginRight: 5,
    paddingTop: 5,
  },
});
